import React from 'react';
import { clientFactory } from './clientFactory.js';
import { client } from './client.js';

const ApiClientContext = React.createContext(undefined);
const useClient = () => {
    const Context = React.useContext(ApiClientContext);
    if (typeof Context === 'undefined')
        return clientFactory(client);
    return Context;
};

export { ApiClientContext, useClient };
//# sourceMappingURL=context.js.map
